<template>
  <div class="slider-miniaturas" v-if="showSlider">
    <button class="nav-voltar" @click="prevSlider()">
      <span>&lsaquo;</span>
    </button>
    <button class="nav-avancar" @click="nextSlider()">
      <span>&rsaquo;</span>
    </button>
    <transition-group>
      <div v-for="(grupo, grupoId) in grupos" :key="`grupo-${grupoId}`">
        <div class="grupo" v-if="grupoAtivo === grupoId">
          <article class="materia" v-for="(materia, matindx) in grupo" :key="matindx">
            <template v-if="materia">
              <a
                v-if="materia.noticia === null"
                :href="materia.url"
                :target="materia.link_externo === '0' ? '_self' : '_blank'"
              >
                <div class="img-holder">
                  <img v-if="materia.arquivo" :src="materia.arquivo.link" :alt="materia.titulo" />
                  <img
                    v-else
                    src="@/assets/imgs/no-image-portal.jpg"
                    :alt="materia.titulo"
                    class="imagem-destaque"
                  />
                </div>
              </a>
              <router-link v-else :to="{ path: makeUrl(materia) }">
                <div class="img-holder">
                  <img v-if="materia.arquivo" :src="materia.arquivo.link" :alt="materia.titulo" />
                  <img
                    v-else
                    src="@/assets/imgs/no-image-portal.jpg"
                    :alt="materia.titulo"
                    class="imagem-destaque"
                  />
                </div>
              </router-link>
            </template>
          </article>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {
  NEXT_PAGE_NOTICIA_ACESSO_RAPIDO,
  PREV_PAGE_NOTICIA_ACESSO_RAPIDO,
} from '../../../store/modules/Revista/home.store';

export default {
  name: 'SliderMiniaturas',
  data() {
    return {
      grupoAtivo: 0,
      grupos: undefined,
      maxNoticiasPorSlider: 4,
      showSlider: false,
    };
  },
  computed: {
    ...mapGetters({
      getPerPage: 'home/getPerPage',
      getNoticiasAcessoRapido: 'home/getNoticiasAcessoRapido',
      userUF: 'user/uf',
    }),
  },
  methods: {
    makeUrl(AcessoRapido) {
      const { noticia } = AcessoRapido;

      if (!noticia) {
        return AcessoRapido.url;
      }

      if (noticia.vivo_se_liga) {
        return `/se-liga/${noticia.slug}`;
      }

      return `/categoria/${noticia.categoria.slug}/post/${noticia.slug}`;
    },
    async initSlider() {
      setTimeout(async () => {
        const noticias = await this.loadNoticias();

        if (noticias.length > 0) {
          const sliders = new Array(this.numeroDeGrupos());

          this.showSlider = true;

          // Preenche os grupos de sliders com as noticias
          for (let i = 0, k = 0; i < this.numeroDeGrupos(); i++) {
            sliders[i] = new Array(this.maxNoticiasPorSlider);

            for (let j = 0; j < this.maxNoticiasPorSlider; j++, k++) {
              sliders[i][j] = noticias[k];
            }
          }

          this.handleGrupos(sliders);
        }
      }, 5000);
    },

    async loadNoticias() {
      // Aguarda até que a promise esteja concluida.
      await this.getHomePageNoticiasAcessoRapido();

      return this.getNoticiasAcessoRapido;
    },

    async loadSlider(next = '') {
      switch (next) {
        case NEXT_PAGE_NOTICIA_ACESSO_RAPIDO:
          this.nextPageAcessoRapido();
          break;
        case PREV_PAGE_NOTICIA_ACESSO_RAPIDO:
          this.prevPageAcessoRapido();
          break;
      }

      const noticias = await this.loadNoticias();

      const sliders = new Array(this.numeroDeGrupos());

      // Preenche os grupos de sliders com as noticias
      for (let i = 0, k = 0; i < this.numeroDeGrupos(); i++) {
        sliders[i] = new Array(this.maxNoticiasPorSlider);

        for (let j = 0; j < this.maxNoticiasPorSlider; j++, k++) {
          sliders[i][j] = noticias[k];
        }
      }

      this.handleGrupos(sliders);
    },
    /**
     * Atualiza o DOM.
     * Trata casos de grupos nulos.
     */
    handleGrupos(sliders = null) {
      // Atualiza o dom para que os grupos sejam renderizados.
      if (sliders) {
        this.grupos = sliders;
      }

      for (let i = 0; i < this.numeroDeGrupos(); i++) {
        // Se o grupo atual tiver o primeiro item indefinido, ou seja, grupo é nulo, volta para o grupo anterior.
        if (this.grupoAtivo === i && this.grupos[i][0] === undefined) {
          this.grupoAtivo = 3;
          this.nextSlider();
          return;
        }
      }
    },
    nextSlider() {
      // Se não for o último slider
      if (this.grupoAtivo < this.numeroDeGrupos() - 1) {
        this.grupoAtivo++;
        this.handleGrupos();
      } else {
        this.grupoAtivo = 0;
        this.loadSlider(NEXT_PAGE_NOTICIA_ACESSO_RAPIDO);
      }
    },
    prevSlider() {
      // Se não for o primeiro grupo
      if (this.grupoAtivo > 0) {
        this.grupoAtivo--;
        this.handleGrupos();
      } else {
        // Vai para o último grupo da página de noticias anterior.
        this.grupoAtivo = this.numeroDeGrupos() - 1;
        this.loadSlider(PREV_PAGE_NOTICIA_ACESSO_RAPIDO);
      }
    },
    numeroDeGrupos() {
      return this.getPerPage / this.maxNoticiasPorSlider;
    },
    ...mapActions({
      getHomePageNoticiasAcessoRapido: 'home/getHomePageNoticiasAcessoRapido',
      nextPageAcessoRapido: 'home/nextPageAcessoRapido',
      prevPageAcessoRapido: 'home/prevPageAcessoRapido',
    }),
  },
  mounted() {
    this.initSlider();
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';

.slider-miniaturas {
  position: relative;
  max-width: 980px;
  margin: 0 auto;
  height: 210px;
  border-bottom: 1px solid $cor_cinza_medium;
  z-index: 0;

  & button {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 0px;
    background: transparent;
    width: 40px;
    height: 40px;
    outline: none;
    padding: 0px;
    margin: 0px;
    top: 27.5%;
    transition: all 0.15s ease-in-out;

    & span {
      color: $cor_roxo;
      font-size: 40px;
      line-height: 0px;
      margin: 0px;
      padding: 0px;
    }

    &:hover {
      transform: scale(1.3);
    }
  }

  & .nav-voltar {
    left: -10px;
  }

  & .nav-avancar {
    right: -10px;
  }

  & .grupo {
    position: absolute;
    left: 50%;
    top: 25px;
    transform: translate(-50%, 0);
    display: flex;
    justify-content: space-between;
    width: 89%;

    & article {
      cursor: pointer;
      width: 190px;
      transition: all 0.15s ease-in-out;

      & a {
        text-decoration: none;
      }

      & .img-holder {
        user-select: none;
        position: relative;
        height: 106px;

        & img {
          border-radius: 5px;
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        & span {
          position: absolute;
          font-size: 10px;
          top: 3px;
          left: 3px;
          color: white;
          padding: 0px 3px;
          border-radius: 3px;
          font-weight: 600;
          background: $cor_rosa;
          opacity: 1 !important;
          z-index: 100;
        }
      }

      & h2 {
          font-family: 'VivoType';
        color: $cor_roxo;
        font-size: 15px;
        line-height: 18px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        -o-text-overflow: ellipsis;
        -ms-text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      &:hover {
        transform: scale(1.025);
      }
    }
  }
}

.v-enter {
  top: 50px !important;
  opacity: 0;
}

.v-enter-to {
  top: 25px !important;
}

.v-leave {
  top: 25px !important;
}

.v-leave-to {
  top: 0px !important;
  opacity: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 1s ease-in-out;
}

@media all and (min-width: 300px) and (max-width: 1000px) {
  .slider-miniaturas {
    width: 100%;
    height: 210px;
    border: 0px;
    background: white;

    & button {
      top: 41%;

      &:hover {
        transform: none !important;
      }
    }

    & .nav-voltar {
      left: 0px;
    }

    & .nav-avancar {
      right: 0px;
    }

    & .grupo {
      flex-wrap: wrap;
      width: 76%;

      & article {
        width: 36vw;
        margin-bottom: 5px;

        & .img-holder {
          height: 70px;

          & span {
            font-size: 7px;
          }
        }

        & h2 {
          font-size: 10px;
          line-height: 10px;
        }
      }
    }
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .slider-miniaturas {
    height: 160px;
    border: 1px solid $cor_cinza_medium;
    margin-bottom: 40px;

    & button {
      top: 27.5%;
    }

    & .nav-voltar {
      left: 20px;
    }

    & .nav-avancar {
      right: 20px;
    }

    & .grupo {
      flex-wrap: no-wrap;
      width: 600px;

      & article {
        width: 18vw;

        & .img-holder {
          height: 80px;

          & span {
            font-size: 8px;
          }
        }

        & h2 {
          font-size: 11px;
          line-height: 11px;
        }
      }
    }
  }
}
</style>
